class SignupAnalytics {
	constructor(passedElement) {
		let self = this;

		self.elem = passedElement;
	}

	init() {
		let self = this;

		const signupType = self.elem.getAttribute('data-signup');
		const emailInput = self.elem.querySelector('.js-signup-email');
		
		self.elem.addEventListener("submit", (evt) => {
			dataLayer.push({
				'event': 'Mailchimp Forms',
				'eventCategory': signupType,
				'eventAction': 'submit',
				'eventLabel': emailInput.value
			});
		});
	}
}

export default SignupAnalytics;